import * as React from "react";
import {
  Img,
  Heading,
  Link,
  Row,
  Section,
  Text,
  Button,
  Column,
} from "@react-email/components";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Layout from "../components/Layout";

export const name = "WaitlistBuyOrderFulfilled";
export const subject = "We got you tickets to {{event_name}}";

export function template(props: {
  event_name: string;
  organization_logo: string;
  first_name: string;
  event_url: string;
  dashboard_url: string;
  cdn_url: string;
  event_image: string;
  quantity: number;
  start_at: string;
  venue: {
    name: string;
  };
  total_display_price: string;
  subtotal_display_price: string;
  ticket_display_price: string;
  card_provider: string;
  card_4_digits: string;
  ticket_type_name: string;
  display_sales_tax: string;
}) {
  return (
    <Layout language="en" title={`We got you tickets to ${props.event_name}`}>
      <Header src={props.organization_logo} />
      <Heading as="h1" style={{ fontSize: "30px" }}>
        We got you tickets to {props.event_name}, see you there
      </Heading>
      <Section>
        <Row>
          <Text style={style.bodyText}>Hey {props.first_name},</Text>
        </Row>
        <Row>
          <Text style={style.bodyText}>
            We are glad to inform you that we managed to find you{" "}
            {props.quantity} of tickets to {props.event_name} on{" "}
            {props.start_at} at {props.venue.name}!
          </Text>
          <Text style={style.bold}>
            You card has been successfully charged {props.total_display_price}.
          </Text>
        </Row>
        <Row style={{ textAlign: "left", marginTop: "24px" }}>
          <Column>
            <Button
              href={props.event_url}
              style={{
                backgroundColor: "black",
                borderRadius: "45px",
                fontWeight: "bold",
                letterSpacing: "6px",
                padding: "15px 20px",
                color: "white",
                fontSize: "14px",
                margin: "0 auto",
                border: "1px solid white",
              }}
            >
              VIEW TICKETS
            </Button>
          </Column>
        </Row>
        <Row
          style={{
            borderTop: "1px solid #333",
            textAlign: "left",
            marginTop: "24px",
            paddingTop: "16px",
          }}
        >
          <Column>
            <Heading as="h2" style={style.h2}>
              Credit Card Charged
            </Heading>
          </Column>
        </Row>
        <Row
          style={{
            textAlign: "left",
            marginTop: "16px",
            border: "1px solid #333",
            borderRadius: "8px",
            padding: "32px",
          }}
        >
          <Column width={"50px"}>
            <Img
              src={`${props.cdn_url}/system/${props.card_provider}`}
              alt={props.card_provider}
            />
          </Column>
          <Column>-{props.card_4_digits}</Column>
        </Row>
      </Section>
      <Section>
        <Row
          style={{
            textAlign: "left",
            marginTop: "24px",
          }}
        >
          <Column>
            <Heading as="h2" style={style.h2}>
              Ticket Order Details
            </Heading>
          </Column>
        </Row>
        <Row
          style={{
            borderBottom: "2px solid #333",
            marginTop: 16,
            marginBottom: 16,
          }}
        >
          <Column width={140}>
            <Heading as="h3" style={style.h3}>
              Ticket Order Details
            </Heading>
          </Column>
          <Column width={100}>
            <Heading as="h3" style={style.h3}>
              Ticket Price
            </Heading>
          </Column>
          <Column width={50}>
            <Heading as="h3" style={style.h3}>
              QTY
            </Heading>
          </Column>
          <Column width={100} align="right">
            <Heading as="h3" style={style.h3}>
              SUBTOTAL
            </Heading>
          </Column>
        </Row>
        <Row>
          <Column
            width={140}
          >{`${props.ticket_type_name} to ${props.event_name}`}</Column>
          <Column width={100}>{props.ticket_display_price}</Column>
          <Column width={50}>{props.quantity}</Column>
          <Column width={100} align="right">
            {props.subtotal_display_price}
          </Column>
        </Row>
        <Row
          style={{
            borderTop: "1px solid #333",
            borderBottom: "2px solid #333",
            marginTop: 16,
          }}
        >
          <Column width={100} align="right" colSpan={4}>
            <Text style={{ color: "#aaa", fontSize: "16px" }}>GRAND TOTAL</Text>
          </Column>
        </Row>
        <Row
          style={{
            marginTop: 16,
          }}
        >
          <Column width={100} align="right" colSpan={4}>
            <Text
              style={{ fontSize: "24px", paddingBottom: 0, marginBottom: 0 }}
            >
              {props.total_display_price}
            </Text>
          </Column>
        </Row>
        {props.display_sales_tax ? (
          <Row>
            <Column width={100} align="right" colSpan={4}>
              <Text style={{ padding: 0, margin: 0, color: "#EF4026" }}>
                {props.display_sales_tax} Sales Tax Included
              </Text>
            </Column>
          </Row>
        ) : null}
        <Row style={{ marginTop: "32px" }}>
          <Column>
            <Text style={{ padding: 0, margin: 0, color: "#aaa" }}>
              If you have any questions or need help please contact
            </Text>
            <Link href={`mailto:support@kydlabs.com`}>support@kydlabs.com</Link>
          </Column>
        </Row>
        <Row style={{ marginTop: "32px" }}>
          <Column>
            <Text style={{ padding: 0, margin: 0, fontSize: "20px" }}>
              We got you,
            </Text>
          </Column>
        </Row>
        <Row style={{ marginTop: "8px" }}>
          <Column>
            <Text style={{ padding: 0, margin: 0, fontSize: "24px" }}>
              Team KYD
            </Text>
          </Column>
        </Row>
        <Row style={{ marginTop: "32px" }}>
          <Column>
            <Text style={{ padding: 0, margin: 0, color: "#aaa" }}>
              This is a system generated message. Do not reply.
            </Text>
          </Column>
        </Row>
      </Section>
      <Footer cdn_url={props.cdn_url} />
    </Layout>
  );
}

const style: Record<string, React.CSSProperties> = {
  h2: {
    fontWeight: "medium",
    fontSize: "18px",
    color: "#aaa",
  },
  h3: {
    fontWeight: "medium",
    fontSize: "16px",
    color: "#aaa",
  },
  bold: {
    display: "inline",
    fontSize: "18px",
  },
  bodyText: {
    fontSize: "18px",
    lineHeight: "28px",
  },
};

template.PreviewProps = {
  event_name: "Test event",
  ticket_type_name: "Table seat",
  first_name: "David",
  card_provider: "visa",
  card_4_digits: "2097",
  quantity: 3,
  start_at: new Date().toLocaleDateString(),
  venue: {
    name: "Le Poisson Rouge",
  },
  subtotal_display_price: "$138.53",
  total_display_price: "$163.47",
  ticket_display_price: "$46.17",
  display_sales_tax: "18%",
  cdn_url:
    "https://coachella.kydlabsdemo.com/e/EV3cfb122a-277b-4c93-9b8d-f8003a015a38/cart?cko-session-id=sid_p5bnqz263kvevpy4ibb7kgrcye",
  event_url:
    "https://coachella.kydlabsdemo.com/e/EV3cfb122a-277b-4c93-9b8d-f8003a015a38/cart?cko-session-id=sid_p5bnqz263kvevpy4ibb7kgrcye",
};

export default template;
